import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { Database, FirebaseFunction } from '../firebase';

export async function claimActiveAuthSession(sessionId, clientInfo = {}) {
	const fn = httpsCallable(FirebaseFunction, 'claimActiveAuthSession');
	const { data } = await fn({ sessionId, clientInfo });
	return data;
}

export async function releaseActiveAuthSession(sessionId) {
	const fn = httpsCallable(FirebaseFunction, 'releaseActiveAuthSession');
	const { data } = await fn({ sessionId });
	return data;
}

export async function getActiveAuthSession(userId) {
	const ref = doc(Database, 'authSessions', userId);
	const snap = await getDoc(ref);
	return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export function subscribeToActiveAuthSession(userId, onNext, onError) {
	const ref = doc(Database, 'authSessions', userId);
	return onSnapshot(ref, onNext, onError);
}
